let tempCounter = 0;
const buildTempId = () => `temp-empresa-${tempCounter++}`;

const toBoolean = (value) =>
  typeof value === "boolean" ? value : value === 1 || value === "1";

export const normalizeEmpresa = (empresa = {}, fallbackId) => ({
  id: empresa.id ?? fallbackId ?? buildTempId(),
  nombre: (empresa.nombre || "").trim(),
  ruc: (empresa.ruc || "").trim(),
  telefono: (empresa.telefono || "").trim(),
  email: (empresa.email || "").trim(),
  tipo: (empresa.tipo || "externa").toLowerCase(),
  activo: toBoolean(empresa.activo ?? true),
  createdAt: empresa.created_at || empresa.createdAt || null,
  updatedAt: empresa.updated_at || empresa.updatedAt || null,
});

export const buildEmpresaPayload = (form) => ({
  nombre: form.nombre.trim(),
  ruc: form.ruc?.trim() || null,
  telefono: form.telefono?.trim() || null,
  email: form.email?.trim() || null,
  tipo: form.tipo || "externa",
  activo: form.activo ? 1 : 0,
});

export const empresaTipoLabel = (tipo) => {
  switch ((tipo || "").toLowerCase()) {
    case "interna":
      return "Interna";
    case "proveedor":
      return "Proveedor";
    default:
      return "Externa";
  }
};

